Vue.component('projectMapPrototype', {
    props: {
        noCanvas: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            // general
            resizeHandleractive: false,
            queryParams: null,
            isMobile: matchMedia('(max-width: 1025px)').matches,
            currentMapId: null,

            baseMapCoords: {},
            currentMapImage: null,
            currentMapShapes: {},
            currentMapPlots: {},

            projectId: startProjectId,
            objectId: startObjectTypeId,
            plotId: startPlotId,
            currentCulture: projectCulture,
            nextMapId: null,
            previousMapId: null,

            mouseDown: false,
            hideScrollRight: true,
            hideScrollLeft: true,

            // svg map / seaDrogon
            seaDragon: null,
            fullyLoaded: false,

            enableZoom: false,
            alternateButtonX: 'right',
            alternateButtonY: 'top',
            minimapX: 'left',
            minimapY: 'bottom',
            minimapLeftLocation: null,
            minimapTopLocation: null,
            navigatorImgHeight: null,

            imgContainer: null,
            imageViewbox: '0 0 0 0',

            hasMoreViews: false,
            shortList: true,

            // filters
            filterUrl: 'GetMap',
            initialized: false,
            newFilterJson: [],
            minPriceValue: null,
            maxPriceValue: null,
            activeFilters: 0,
            priceChanged: false,

            // slider
            sliderList: null,
            currentSlider: null,
            sliderarray: [],
        }
    },
    mounted() {
        const root = this;

        // Load screen not necessary for mobile
        if (root.isMobile) {
            root.fullyLoaded = true
        }
        
        // Add horizontal scroll to filter row
        root.horizontalScroll()

        // Set general data
        root.queryParams = new URLSearchParams(window.location.search);

        window.addEventListener('resize', event => {
            root.isMobile = matchMedia('(max-width: 1025px)').matches
        })

        root.imgContainer = document.querySelector('.plotMap__map');
        Vue.nextTick(() => {
            this.mapElement = document.getElementById('container');
        });

        if (this.queryParams.has('projectId')) {
            this.projectId = this.queryParams.get('projectId')
        }

        if (this.plotId) {
            this.getMapForPlot();
        } else if (this.objectId) {
            root.filterUrl = 'GetMapForObjectType'
            this.getMapForObjectType();
        } else if (this.queryParams.has('mapId')) {
            this.currentMapId = this.queryParams.get('mapId')
            this.getNewMapView(this.queryParams.get('mapId'));
        } else {
            this.getFirstMapId(this.projectId);
        }

        // Set mouseDown, so you don't go to another map when you drag over a plot or shape
        window.addEventListener('mousedown', function() {
            root.mouseDown = true
        }, false)

        window.addEventListener('mouseup', function() {
            root.mouseDown = false
        }, false)

        addEventListener('orientationchange', (event) => {
            if (screen.width > 1025) {
                root.isMobile = false
            } else {
                root.isMobile = true
            }

            if (this.currentSlider) this.currentSlider.destroy();
            
            if (root.seaDragon) {
                root.seaDragon.destroy();
            }

            Vue.nextTick(() => {
                root.imgContainer = document.querySelector('.plotMap__map');
                root.initButtonLocations()
            });

            if (root.isMobile) root.initSlider();
        });

        addEventListener("pagehide", () => { this.fullyLoaded = true });
    },
    computed: {
        alternativeMaps() {
            // Only show first 4 alternate maps on load
            if (this.baseMapCoords.Alternates) {
                if (this.shortList) {
                    return this.baseMapCoords.Alternates.slice(0, 4)
                }
            }

            return this.baseMapCoords.Alternates
        },
        firstPlotOption() {
            return this.currentMapPlots[0]
        }
    },
    filters: {
        formatCurrency(input) {
            const newInput = parseInt(input, 10)
            return newInput.toLocaleString("nl-NL", { style: 'currency', currency: 'EUR', minimumFractionDigits: 0 })
        },
        sliceText(input, strLength) {
            const newStringLength = parseInt(strLength, 10)
            if (matchMedia('(max-width: 1025px)').matches && input.length > newStringLength) {
                return input.slice(0, newStringLength).concat('...')
            }

            return input
            
        }
    },
    methods: {
        // general
        resizeHandler() {
            if (!this.resizeHandleractive) {
                window.addEventListener('resize', function() {
                    if (this.isMobile && this.currentSlider) this.currentSlider.destroy();
            
                    // Place buttons and minimap
                    this.initButtonLocations()
                    this.resizeHandleractive = true
                })
            }
            
        },
        getFirstMapId(id) {
            // Get first map id bases on ProjectId form cshtml file
            const root = this
            fetch(`/umbraco/api/plotmap/GetFirstMapId?projectId=${id}&culture=${root.currentCulture}`, {
                method: 'GET',
                headers: {
                    'Accept-Language': document.documentElement.lang,
                },
                credentials: "same-origin",
            }).then((response) => {
                    return response.json();
                }).then((response) => {
                if (response !== null) {
                    const projectId = response
                    root.getNewMapView(projectId)
                }
            });
        },
        getNewMapView(id, clickFromList, url = null, redirectUrl = null) {
            if (redirectUrl) {
                window.open(redirectUrl, '_self');
                return;
            }

            // Get corret map and data
            const root = this;
            if(!root.isMobile) root.fullyLoaded = false

            // If dragged over clickeble shape/plot do not fire call
            if (clickFromList && root.mouseDown) return
            if (!id && !url) return

            // If mapId is null go to url
            if (!id) {
                if (clickFromList && this.mouseDown || !url) return
                this.fullyLoaded = true
                window.open( url, '_blank' );
                return
            }

            root.resetMap(id, root.projectId);
            
            const finishedJson = {
                MapId: id,
                ProjectId: root.projectId,
                Filters: root.newFilterJson,
                Culture: root.currentCulture
            }
            fetch('/umbraco/api/plotmap/GetMap', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': document.documentElement.lang,
                },
                credentials: 'same-origin',
                body: JSON.stringify(finishedJson)
            }).then((response) => {
                return response.json();
            }).then((response) => {
                    if (response !== null) {
                        root.baseMapCoords = response;
                        root.currentMapImage = root.baseMapCoords.Image
                        root.currentMapShapes = root.baseMapCoords.Shapes
                        root.currentMapPlots = root.baseMapCoords.Plots
    
                        root.nextMapId = root.baseMapCoords.NextMapId
                        root.previousMapId = root.baseMapCoords.PreviousMapId
    
                        root.enableZoom = root.baseMapCoords.EnableZoom
    
                        // Destroy slider before init new one
                        if (this.isMobile && this.currentSlider) this.currentSlider.destroy();
    
                        // Place buttons and minimap
                        root.initButtonLocations()

                        if (root.baseMapCoords.Filters) {
                            root.hideScrollLeft = true
                            root.hideScrollLeft = true

                            root.initFiltersFromBase()

                            Vue.nextTick(() => {
                                if (root.baseMapCoords.Filters.length > 4) {
                                    root.handleSwipe()
                                } else {
                                    root.hideScrollLeft = true
                                    root.hideScrollRight = true
                                }
                            })
                        }
                    }
            })
        },
        getMapForObjectType() {
            const root = this;
            if(!root.isMobile) root.fullyLoaded = false
            
            const finishedJson = {
                ObjectTypeId: root.objectId,
                ProjectId: root.projectId,
                Culture: root.currentCulture,
            }

            fetch('/umbraco/api/plotmap/GetMapForObjectType', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': document.documentElement.lang,
                },
                credentials: 'same-origin',
                body: JSON.stringify(finishedJson)
            }).then((response) => {
                return response.json();
                }).then((response) => {
                    if (response !== null) {
                        root.baseMapCoords = response;
                        root.currentMapImage = root.baseMapCoords.Image
                        root.currentMapShapes = root.baseMapCoords.Shapes
                        root.currentMapPlots = root.baseMapCoords.Plots
    
                        root.nextMapId = root.baseMapCoords.NextMapId
                        root.previousMapId = root.baseMapCoords.PreviousMapId
    
                        root.enableZoom = root.baseMapCoords.EnableZoom
    
                        // Destroy slider before init new one
                        if (this.isMobile && this.currentSlider) this.currentSlider.destroy();
    
                        // Place buttons and minimap
                        root.initButtonLocations()

                        if (root.baseMapCoords.Filters) {
                            root.initFiltersFromBase()
                            root.hideScrollLeft = true
                            root.hideScrollLeft = true

                            Vue.nextTick(() => {
                                if (root.baseMapCoords.Filters.length > 4) {
                                    root.handleSwipe()
                                } else {
                                    root.hideScrollLeft = true
                                    root.hideScrollRight = true
                                }
                            })
                        }
                    }
            })
        },
        getMapForPlot() {
            const root = this;
            if(!root.isMobile) root.fullyLoaded = false
            
            const finishedJson = {
                PlotId: root.plotId,
                ObjectTypeId: root.objectId,
                ProjectId: root.projectId,
                Culture: root.currentCulture,
            }

            fetch('/umbraco/api/plotmap/GetMapForPlot', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': document.documentElement.lang,
                },
                credentials: 'same-origin',
                body: JSON.stringify(finishedJson)
            }).then((response) => {
                return response.json();
                }).then((response) => {
                    if (response !== null) {
                        root.baseMapCoords = response;
                        root.currentMapImage = root.baseMapCoords.Image
                        root.currentMapShapes = root.baseMapCoords.Shapes
                        root.currentMapPlots = root.baseMapCoords.Plots
    
                        root.nextMapId = root.baseMapCoords.NextMapId
                        root.previousMapId = root.baseMapCoords.PreviousMapId
    
                        root.enableZoom = root.baseMapCoords.EnableZoom
    
                        // Destroy slider before init new one
                        if (this.isMobile && this.currentSlider) this.currentSlider.destroy();
    
                        // Place buttons and minimap
                        root.initButtonLocations()

                        // if (root.baseMapCoords.Filters) {
                        //     root.initFiltersFromBase()
                        // }

                        Vue.nextTick(() => {
                            root.sliderarray = root.currentMapPlots.slice(1)
                        })
                    }
            })
        },
        initButtonLocations() {
            // Handles the location of the alternative buttons and minimap on the map
            const root = this

            if (root.baseMapCoords.AlternateButtonX !== '') {
                root.alternateButtonX = root.baseMapCoords.AlternateButtonX 
            }
            if (root.baseMapCoords.AlternateButtonY !== '') {
                root.alternateButtonY = root.baseMapCoords.AlternateButtonY 
            }
            if (root.baseMapCoords.MinimapY !== '') {
                root.minimapY = root.baseMapCoords.MinimapY 
            }
            if (root.baseMapCoords.MinimapX !== '') {
                root.minimapX = root.baseMapCoords.MinimapX 
            }
            
            const imgWidth = root.imgContainer.offsetWidth;
            const imgHeight = root.imgContainer.offsetHeight;
            
            if (root.baseMapCoords.Alternates) {
                if (root.baseMapCoords.Alternates.length > 4) {
                    root.hasMoreViews = true;
                    root.shortList = true;
                } else {
                    root.hasMoreViews = false;
                    root.shortList = false;
                }
            }

            if (root.baseMapCoords.MinimapY === root.baseMapCoords.AlternateButtonY && root.baseMapCoords.MinimapX === root.baseMapCoords.AlternateButtonX) {
                root.alternateButtonX = 'right'
                root.alternateButtonY = 'top'
                root.minimapX = 'left'
                root.minimapY = 'bottom'
            }

            Vue.nextTick(() => {
                const imgElement = new Image;
                imgElement.src = root.currentMapImage 
                imgElement.addEventListener('load', e => {
                    // Set the viewbox to the original width and height of the map that is drawn on
                    root.imageViewbox = `0 0 ${root.baseMapCoords.OriginalImageWidth} ${root.baseMapCoords.OriginalImageHeight}`
                    const shape = document.querySelector('.plotMap__map-svg');
                    shape.setAttribute('viewBox', root.imageViewbox);

                    // Calculate aspect ratio for navigator
                    root.navigatorImgHeight = (parseInt(root.baseMapCoords.OriginalImageHeight, 10) / parseInt(root.baseMapCoords.OriginalImageWidth, 10)) * 145;

                    //  Place minimap on map
                    if (root.minimapY === 'bottom') {
                        root.minimapTopLocation = (imgHeight - root.navigatorImgHeight) - 24
                    }
                    if (root.minimapX === 'right') {
                        root.minimapLeftLocation = (imgWidth - 145) - 24
                    }
                    if (root.minimapX === 'right' && root.minimapY === 'bottom') {
                        root.minimapLeftLocation = (imgWidth - 145) - 80
                    }

                    if (root.seaDragon) {
                        root.seaDragon.destroy();
                    }

                    if (root.isMobile) root.initSlider();

                    if (root.enableZoom && !root.noCanvas) {
                        root.fullyLoaded = false
                        if (!root.isMobile) root.initOpenSeaDragon();
                        root.seaDragon.viewport.goHome()
                    } else if (!root.enableZoom) {
                        root.fullyLoaded = true
                    }
                })
            });
        },
        goToPlotDetail(url, clickFromList) {
            this.fullyLoaded = false
            if (clickFromList && this.mouseDown || !url || url === location.href) {
                this.fullyLoaded = true
                return
            } 
            location.href = url
        },
        updateQueryUrl() {
            window.history.replaceState({}, '', `${window.location.pathname}?${this.queryParams}`);
        },
        updateUrl() {
            history.pushState(null, '', `${document.location.pathname}?${this.getUrlParams()}`);
        },
        getUrlParams() {
            // Delete mapId and projectId because they are also present in serializeFormData
            this.queryParams.delete('mapId')
            this.queryParams.delete('projectId')

            const filterForm = document.querySelector('.plotMap__filters')
            const currentFilters = this.serializeFormData(filterForm)
            const params = new URLSearchParams(currentFilters);
            return params.toString();
        },
        scrollFilterRow(scrollRight) {
            const scrollRow = document.querySelector('[data-filter-scroll-container]')
            if (scrollRight) {
                scrollRow.scrollLeft += 100
            } else {
                scrollRow.scrollLeft -= 100
            }

            this.handleSwipe()
        },
        handleSwipe() {
            const scrollRow = document.querySelector('[data-filter-scroll-container]')
            if (scrollRow.scrollLeft > 0) {
                this.hideScrollLeft = false

                if (scrollRow.offsetWidth + scrollRow.scrollLeft >= scrollRow.scrollWidth) {
                    this.hideScrollRight = true
                    this.hideScrollLeft = false
                } else {
                    this.hideScrollRight = false
                }
            } else {
                this.hideScrollLeft = true

                if (scrollRow.scrollLeft < scrollRow.scrollWidth) {
                    this.hideScrollRight = false
                }
            }
        },

        // svg map / seaDrogon
        initOpenSeaDragon() {
            const root = this
            this.seaDragon = OpenSeadragon({
                id: 'plotMap',
                prefixUrl: "https://static.zoomhub.net/openseadragon-images/",
              
                tileSources: {
                  type: "image",
                  url: this.currentMapImage,
                  buildPyramid: false,
                  overlays: [
                    {
                      id: 'plotmap-svg',
                      x: 0,
                      y: 0,
                      width: 1
                    },
                    {
                        px: 6425,
                        py: 0,
                        id: 'html-overlay'
                    }
                  ]
                },
                minZoomLevel: 1,
                maxZoomLevel: 2,
                zoomInButton: 'zoom-in',
                zoomOutButton: 'zoom-out',
              
                constrainDuringPan: true,
                panHorizontal: true,
                panVertical: true,
                
                visibilityRatio: 1,
              
                showNavigator: true,
                navigatorAutoFade: false,
                navigatorPosition: "ABSOLUTE",
                navigatorTop: this.minimapY === 'top' ? '24px' : this.minimapTopLocation + 'px',
                navigatorLeft: this.minimapX === 'left' ? '24px' : + this.minimapLeftLocation + 'px',
                navigatorHeight: this.navigatorImgHeight,
                navigatorWidth: "145px",
                zoomPerClick: 1.5,
                homeFillsViewer: true
            });

            this.seaDragon.addHandler('open', function(){
                var tiledImage = root.seaDragon.world.getItemAt(0);
                tiledImage.addHandler('fully-loaded-change', function() {
                    root.fullyLoaded = true
                });
            });

            // Disable click and zoom on map for zoom, needs to be done after initialization 
            this.seaDragon.gestureSettingsMouse.clickToZoom = false
            this.seaDragon.innerTracker.scrollHandler = false;

            // Set mouseDown, so you don't go to another map when you drag over a plot or shape
            this.seaDragon.addHandler('canvas-drag', function() {
                root.mouseDown = true
            });
            this.seaDragon.addHandler('canvas-release', function() {
                root.mouseDown = false
            });
        },
        highlightPlot(e, highlight, plotItemFromList = null, hoveredPlotItem = null) {
            let plotItem
            let listItemId = null
            let listItem = null
            let tooltip = null
            let samePlots = null

            if (e) {
                plotItem = e.target;

                listItemId = plotItem.id.split('map-').pop();
                listItem = document.querySelector(`[data-slide-id="list-${listItemId}"]`)

                tooltip = document.querySelector(`#tooltip-${listItemId}`)
            } else {
                plotItem = plotItemFromList
            }

            if (hoveredPlotItem && hoveredPlotItem.Coords.length > 1) {
                samePlots = document.querySelectorAll(`#map-${hoveredPlotItem.Id}`)
            }
            
            if (highlight) {
                plotItem.style.opacity = '1'

                if (samePlots) {
                    samePlots.forEach(plot => {
                        plot.style.opacity = '1'
                    })
                }

                if (listItem) {
                    listItem.classList.add('is-active');
                }

                const wrapperElement = document.querySelector('.plotMap__map__wrapper')
                if (tooltip && !this.mouseDown) {
                    tooltip.style.display = 'block'
                    const tooltipWidth = tooltip.offsetWidth
                    const tooltipheight = tooltip.offsetHeight + 10

                    const rect = wrapperElement.getBoundingClientRect();
                    

                    document.addEventListener('mousemove', function(e) {
                        const x = e.clientX - rect.left; //x position within the element.
                        const y = e.clientY - rect.top;  //y position within the element.

                        tooltip.style.left = (x - (tooltipWidth / 2)) + 'px'
                        tooltip.style.top = (y - tooltipheight) + 'px'
                    }, false);
                }
            } else {
                plotItem.style.opacity = '0';
                if (samePlots) {
                    samePlots.forEach(plot => {
                        plot.style.opacity = '0'
                    })
                }
                if (listItem) {
                    listItem.classList.remove('is-active');
                }

                if (tooltip) {
                    tooltip.style.display = 'none'

                    document.removeEventListener('mousemove', function(){}, true)

                    tooltip.style.left = '0px';
                    tooltip.style.top = '0px';
                }
            }
        },
        resetMap(id, projectId) {
            const allPlots = document.querySelectorAll('[data-map-path]');
            allPlots.forEach(plot => {
                plot.style.opacity = '0';
            });

            this.queryParams.set('mapId', id);
            this.currentMapId = id
            this.queryParams.set('projectId', projectId);
            this.updateQueryUrl();

        },
        highlightFromList(e, highlight, id, activeSlide, plotItem) {
            let listDOMItem;

            if (activeSlide) {
                listDOMItem = activeSlide;
            } else {
                listDOMItem = e.target;
            }
            const plotOnMap = document.querySelector(`#map-${id}`);

            if (highlight) {
                listDOMItem.classList.add('is-active');
                this.highlightPlot(null, true, plotOnMap, plotItem)
            } else {
                listDOMItem.classList.remove('is-active');
                this.highlightPlot(null, false, plotOnMap, plotItem)
            }  
        },

        // filters
        horizontalScroll() {
            const elem = document.querySelector('[data-filter-scroll-container]')
            
            // when mouse is in filter container, enable horizontal scroll
            if (!elem) return
            elem.addEventListener('scroll', e => {
                this.handleSwipe()
            })
            elem.addEventListener('wheel', (event) => {
                if (!event.target.closest('.plotMap__filters__dropdown__list')) {
                    event.preventDefault();
                    elem.scrollLeft += event.deltaY

                    this.handleSwipe()
                }
            });
        },
        toggledropdown(event, childDropdown) {
            event.preventDefault();
            const clickedElement = event.target
            const parent = clickedElement.closest('[data-dropdown]')
            const isExpanded = parent.getAttribute('aria-expanded') === 'true' ? true : false
            const currentOpen = document.querySelector('[data-dropdown][aria-expanded="true"]')
            const currentOpenChild = document.querySelector('[data-dropdown].is-child[aria-expanded="true"]')

            parent.setAttribute('aria-expanded', !isExpanded)

            if (!childDropdown) {
                if (currentOpen || currentOpen === parent) currentOpen.setAttribute('aria-expanded', 'false')
                document.addEventListener('click', function(e) {
                    if (!e.target.closest('.plotMap__filters__dropdown')) {
                        parent.setAttribute('aria-expanded', 'false')
                    }
                })
            } else {
                if (currentOpenChild || currentOpenChild === parent) currentOpenChild.setAttribute('aria-expanded', 'false')
                document.addEventListener('click', function(e) {
                    if (!e.target.closest('.plotMap__filters__dropdown--child')) {
                        parent.setAttribute('aria-expanded', 'false')
                    }
                })
            }
        },
        fireFilter() {
            // Called for filtering
            const root = this;
            const finishedJson = {
                MapId: root.currentMapId,
                ProjectId: root.projectId,
                ObjectTypeId: root.objectId,
                Filters: root.newFilterJson,
                Culture: root.currentCulture
            }

            fetch(`/umbraco/api/plotmap/${root.filterUrl}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': document.documentElement.lang,
                },
                credentials: 'same-origin',
                body: JSON.stringify(finishedJson)
            }).then((response) => {
                return response.json();
                }).then((response) => {
                if (response !== null && response !== '') {
                    // Set new general data
                    root.activeFilters = 0
                    root.baseMapCoords = response
                    root.currentMapImage = root.baseMapCoords.Image
                    root.currentMapShapes = root.baseMapCoords.Shapes
                    root.currentMapPlots = root.baseMapCoords.Plots
                    if (this.isMobile && this.currentSlider) this.currentSlider.destroy();

                    if (root.baseMapCoords.Filters) {
                        root.newFilterJson = root.baseMapCoords.Filters
                    }

                    Vue.nextTick(() => {
                        // Redraw slider
                        if (root.isMobile) this.initSlider()

                        const allCheckedInputs = document.querySelectorAll('input:checked')
                        root.activeFilters = allCheckedInputs.length

                        //if (root.minPriceValue) root.activeFilters = root.activeFilters + 1
                        //if (root.maxPriceValue) root.activeFilters = root.activeFilters + 1

                        this.updateUrl()
                    })
                }
            })
        },
        closeDropdown(event) {
            event.preventDefault()
            const currentOpen = document.querySelector('[data-dropdown][aria-expanded="true"]')
            currentOpen.setAttribute('aria-expanded', 'false')
        },
        resetFilter(event, filter) {
            const dropdownParent = event.target.closest('.plotMap__filters__dropdown')

            // Reset all field in DOM 
            event.preventDefault()
            const parentList = event.target.parentNode

            if (filter.Type === 'range') {
                this.minRangeSliderValue = null
                this.maxRangeSliderValue = null
                filter.ActiveMinValue = null
                filter.ActiveMaxValue = null

                const inputElements = parentList.querySelectorAll('input[type="text"]')
                inputElements.forEach(input => {
                    input.value = null
                })
            } else {
                const dropdownTriggerSpan = dropdownParent.querySelector('[data-dropdown-text]')
                if (dropdownTriggerSpan) dropdownTriggerSpan.innerHTML = dropdownParent.dataset.startValue
                dropdownParent.classList.remove('has-new-value')

                const inputElements = parentList.querySelectorAll('input:checked')
                inputElements.forEach(input => {
                    input.checked = false
                })
    
                filter.Values.forEach(item => {
                    item.Active = false
                })
            }

            this.fireFilter()
            
            // Close dropdown immediately after clicking reset button
            this.closeDropdown(event)

        },
        deleteAllFilters(event) {
            event.preventDefault()
            this.minPriceValue = null
            this.maxPriceValue = null
            this.newFilterJson = []

            const allDropdowns = document.querySelectorAll('[data-dropdown-component]')
            allDropdowns.forEach(element => {
                const dropdownTriggerSpan = element.querySelector('[data-dropdown-text]')
                if (dropdownTriggerSpan) dropdownTriggerSpan.innerHTML = element.dataset.startValue
                element.classList.remove('has-new-value')
            })
            this.fireFilter()
        },
        serializeFormData(form) {
            // Get all data from form to generate new querystring
            const responseObject = {};
            const fieldNames = [];

            [...form.elements].forEach(function (field) {
                if (fieldNames.includes(field.name) || !field.name || field.disabled || (field.type !== 'checkbox' && field.type !== 'text' && field.type !== 'radio')) return;
    
                responseObject[field.name] = [];
    
                [...form.elements].filter(x => x.name === field.name).forEach(correspondingField => {
                    if (field.type === 'checkbox') {
                        if (correspondingField.checked) responseObject[field.name].push(correspondingField.value);
                    } else if (field.type === 'radio') {
                        if (correspondingField.checked) {
                            responseObject[field.name] = (correspondingField.value);
                        }
                    } else {
                        if (correspondingField.value) {
                            responseObject[field.name] = (correspondingField.value);
                        }
                        
                    }
                });

                fieldNames.push(field.name);
            });

            // Remove empty key value pairs for cleanliness 
            const finishedResponseObject = {}
            for (const [key, value] of Object.entries(responseObject)) {
                
                const keyelement = key
                if (value.length > 0) {
                    finishedResponseObject[keyelement] = value;
                }
            }

            // Add Map and Project ID to url
            finishedResponseObject.mapId = this.currentMapId
            finishedResponseObject.projectId = this.projectId

            return finishedResponseObject;
        },
        handleValueChange(val, item, event, newdropdownText) {
            if (val.Value === item.Value) {
                const clickedInput = event.target;
                val.Active = clickedInput.checked;
                newdropdownText = val.Label
            } else {
                val.Active = false
            }
        },
        handleFilterChange(event, item, filterCode, pricetype = null) {
            let newdropdownText = null
            const inputType = event.target.type
            const dropdownParent = event.target.closest('.plotMap__filters__dropdown')


            this.newFilterJson.forEach(filterItem => {
                if (filterItem.Code === filterCode) {
                    if (inputType === 'radio') {
                        if (pricetype === 'priceMin') {
                            filterItem.MinValues.forEach(val => {
                                this.handleValueChange(val, item, event, newdropdownText)
                                if (val.Value === item.Value) {
                                    filterItem.ActiveMinValue = item.Value;
                                    this.minPriceValue = filterItem.ActiveMinValue;
                                    val.Active = item.Active;
                                }
                            })
                        } else if (pricetype === 'priceMax') {
                            filterItem.MaxValues.forEach(val => {
                                this.handleValueChange(val, item, event, newdropdownText)
                                if (val.Value === item.Value) {
                                    filterItem.ActiveMaxValue = item.Value
                                    this.maxPriceValue = filterItem.ActiveMaxValue
                                    val.Active = item.Active;
                                }
                            })
                        } else {
                            filterItem.Values.forEach(val => {
                                this.handleValueChange(val, item, event, newdropdownText)
                            })
                        }
                    } else if (inputType === 'checkbox') {
                        let amount = 0
                        filterItem.Values.forEach(val => {
                            if (val.Value === item.Value) {
                                const clickedInput = event.target;
                                val.Active = clickedInput.checked;
                            }

                            if (val.Active === true) {
                                amount = amount + 1
                                if (newdropdownText === null) {
                                    newdropdownText = val.Label
                                }
                                else {
                                    const removed = newdropdownText.split('&nbsp +')[0]
                                    newdropdownText = removed + '&nbsp +' + (amount - 1)
                                }
                            }
                        })
                    }
                }
            })

            if (pricetype) {
                this.priceChanged = true
                const childDropdown = event.target.closest('.plotMap__filters__dropdown--child')
                const dropdown = childDropdown.querySelector('[data-dropdown]')
                if (dropdown) dropdown.setAttribute('aria-expanded', false)
            }

            if (newdropdownText === '' || newdropdownText === null) {
                newdropdownText = dropdownParent.dataset.startValue
                dropdownParent.classList.remove('has-new-value')
            } else {
                dropdownParent.classList.add('has-new-value')
            }

            const dropdownTriggerSpan = dropdownParent.querySelector('[data-dropdown-text]')
            if (dropdownTriggerSpan) dropdownTriggerSpan.innerHTML = newdropdownText

            this.fireFilter()
        },
        initFiltersFromBase(isObjectType) {
            const root = this
            this.newFilterJson = root.baseMapCoords.Filters

            // Only on first load
            if (!root.initialized) {
                const currentFilters = Object.fromEntries(this.queryParams) || {};
                root.newFilterJson.forEach(item => {
                    // if (item.Code === 'price') {
                    //     if (item.Type === 'range') {
                    //         if (currentFilters.priceFrom) {
                    //             root.minRangeSliderValue =  currentFilters.priceFrom
                    //             const newValue = currentFilters.priceFrom.replace('€', '').replace('.', '')
                    //             item.ActiveMinValue = parseInt(newValue, 10)
                    //         }

                    //         if (currentFilters.priceTo) {
                    //             root.maxRangeSliderValue = currentFilters.priceTo
                    //             const newValue = currentFilters.priceTo.replace('€', '').replace('.', '')
                    //             item.ActiveMaxValue = parseInt(newValue, 10)
                    //         }
                    //     }
                    // }

                    if (currentFilters.hasOwnProperty(item.Code)) {
                        const keyValue = item.Code
                        let newdropdownText = null

                        if (item.Type === 'checkbox') {
                            let amount = 0
                            if (currentFilters[keyValue].indexOf(',') !== -1) {
                                const resultArray = currentFilters[keyValue].split(',')
                                resultArray.forEach(el => {
                                    const result = item.Values.find( ({ Value }) => Value === el);
                                    result.Active = true

                                    amount = amount + 1
                                    if (newdropdownText === null) {
                                        newdropdownText = result.Label
                                    } else {
                                        const removed = newdropdownText.split('&nbsp +')[0]
                                        newdropdownText = removed + '&nbsp +' + (amount - 1)
                                    }
                                })
                            } else {
                                const result = item.Values.find( ({ Value }) => Value === currentFilters[keyValue]);
                                result.Active = true
                                newdropdownText = result.Label
                            }
                        }

                        if (item.Type === 'radio') {
                            const result = item.Values.find( ({ Value }) => Value === currentFilters[keyValue]);
                            result.Active = true
                            newdropdownText = result.Label
                        }

                        Vue.nextTick(() => {
                            const dropdown = document.querySelector(`#drop-${keyValue}`)
                            if (newdropdownText === '' || newdropdownText === null) {
                                newdropdownText = dropdown.dataset.startValue
                                dropdown.classList.remove('has-new-value')
                            } else {
                                dropdown.classList.add('has-new-value')
                            }
                
                            const dropdownTriggerSpan = dropdown.querySelector('[data-dropdown-text]')
                            dropdownTriggerSpan.innerHTML = newdropdownText
                        })
                    }
                })

                root.fireFilter()
                root.initialized = true
            }
        },

        // slider
        initSlider() {
            const root = this;
            const sliderElement = document.querySelector('.plotMap__list__slider');

            this.currentSlider = new Flickity(sliderElement, {
                contain: true,
                cellAlign: 'left',
                watchCSS: true,
                wrapAround: false,
                prevNextButtons: false,
                pageDots: true,
                adaptiveHeight: false
            });

           
            if (this.isMobile) {
                root.checkForActiveSlide(true);
                this.currentSlider.on( 'change', function( index ) {root.checkForActiveSlide(true)});
            }
        },
        checkForActiveSlide(highlight) {
            const activeSlide = document.querySelector('.plotMap__list__item.is-selected');
            const allSlides = document.querySelectorAll('.plotMap__list__item');
            allSlides.forEach(slide => {
                const sliderId = slide.dataset.slideId;
                this.highlightFromList(null, false, sliderId.split('-').pop(), slide);
            })

            if (activeSlide) {
                const sliderId = activeSlide.dataset.slideId;
                this.highlightFromList(null, highlight, sliderId.split('-').pop(), activeSlide);
            }
        }
    }
});